/* eslint-disable */
import {
  Autocomplete,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import SearchIcon from "@mui/icons-material/Search";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { Box } from "@mui/system";
import { Add } from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState, useContext } from "react";
import { getCristalProductos, getCristalProducto } from "../../services/CristalProductoService";
import { getCacheData } from "../../services/CacheService";
import { getBlCrSubMarcas } from "../../services/BlCrSubMarcaService";
import Message from "../../utils/Message";
import CristalProductoDialog from "./CristalProductoDialog";
import WaitingDialog from "../../utils/WaitingDialog";
import AuthContext from "../../contexts/AuthContext";

const initialSearchData = {
  descripcion: "",
  descripcionCorta: "",
  idBlCrTipo: null,
  idBlCrMaterial: null,
  idCrOrigen: null,
  idBlCrMarca: null,
  idBlCrSubmarca: null,
  idBlCrColor: null,
  idBlCrDisponibleOs: null,
  estado: "habilitado",
};

const estadoOptions = [
  {
    id: "todo",
    descripcion: "Todo",
  },
  {
    id: "habilitado",
    descripcion: "Habilitado",
  },
  {
    id: "deshabilitado",
    descripcion: "Deshabilitado",
  },
];

const disponibleOsOptions = [
  {
    id: "todo",
    descripcion: "Todos",
  },
  {
    id: "si",
    descripcion: "Si",
  },
  {
    id: "no",
    descripcion: "No",
  },
];

const nameItemsText = "Productos de Cristales";
//
// #############################################################################
//
const CristalProductoTable = () => {
  const [searchData, setSearchData] = useState(initialSearchData);
  const [itemsCrud, setItemsCrud] = useState([]);
  const [itemCrud, setItemCrud] = useState({});
  const [actionCrud, setActionCrud] = useState("");
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [blCrTipos, setBlCrTipos] = useState([]);
  const [blCrMateriales, setBlCrMateriales] = useState([]);
  const [crOrigenes, setCrOrigenes] = useState([]);
  const [blCrMarcas, setBlCrMarcas] = useState([]);
  const [blCrSubMarcas, setBlCrSubMarcas] = useState([]);
  const [blCrColores, setBlCrColores] = useState([]);
  const [valueACBlCrMarca, setValueACBlCrMarca] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACBlCrMarca, setInputValueACBlCrMarca] = useState("");
  const [valueACBlCrSubMarca, setValueACBlCrSubMarca] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACBlCrSubMarca, setInputValueACBlCrSubMarca] = useState("");
  const [valueACBlCrMaterial, setValueACBlCrMaterial] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACBlCrMaterial, setInputValueACBlCrMaterial] = useState("");
  const [valueACBlCrTipo, setValueACBlCrTipo] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACBlCrTipo, setInputValueACBlCrTipo] = useState("");
  const [valueACBlCrColor, setValueACBlCrColor] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACBlCrColor, setInputValueACBlCrColor] = useState("");
  const [valueACBlCrDisponibleOs, setValueACBlCrDisponibleOs] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACBlCrDisponibleOs, setInputValueACBlCrDisponibleOs] = useState("");
  const [valueACCrOrigen, setValueACCrOrigen] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACCrOrigen, setInputValueACCrOrigen] = useState("");

  const { hasPermission } = useContext(AuthContext);
  const _crearCristalProducto = hasPermission("cristal-producto-c");
  const _editarCristalProducto = hasPermission("cristal-producto-e");
  const _habilitarCristalProducto = hasPermission("cristal-producto-h");
  const _deshabilitarCristalProducto = hasPermission("cristal-producto-d");

  const tableColumns = [
    {
      field: "descripcion",
      headerName: "Descripción",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_bl_cr_marca",
      headerName: "Marca",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_bl_cr_marca;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_bl_cr_submarca",
      headerName: "Submarca",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_bl_cr_submarca;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_bl_cr_material",
      headerName: "Material",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_bl_cr_material;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_bl_cr_tipo",
      headerName: "Tipo",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_bl_cr_tipo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_cr_origen",
      headerName: "Origen",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_cr_origen;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_bl_cr_color",
      headerName: "Color",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_bl_cr_color;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "habilitado",
      headerName: "Habilitado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.habilitado ? "SI" : "";
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {params.row.habilitado && _editarCristalProducto && (
            <Tooltip title="editar">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() =>
                  handleClickActionCrud(params.row, "update")
                }
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
          {params.row.habilitado && _deshabilitarCristalProducto && (
            <Tooltip title="deshabilitar">
              <IconButton
                size="small"
                aria-label="disable"
                onClick={() =>
                  handleClickActionCrud(params.row, "disable")
                }
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}

          {!params.row.habilitado && _habilitarCristalProducto && (
            <Tooltip title="habilitar">
              <IconButton
                size="small"
                aria-label="enable"
                onClick={() =>
                  handleClickActionCrud(params.row, "enable")
                }
              >
                <AddCircleOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    getRowId: (row) => row.id,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    loadBlCrTipos();
    loadBlCrMateriales();
    loadCrOrigenes();
    loadBlCrMarcas();
    loadBlCrColores();
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    load();
  }, [currentPage, rowsPerPage]);
  //
  // ################################################################################
  //
  useEffect(() => {
    setValueACBlCrSubMarca(null);
    if (valueACBlCrMarca.id && valueACBlCrMarca.id !== "") {
      loadBlCrSubMarcas(valueACBlCrMarca.id);
    }
  }, [valueACBlCrMarca]);
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setSearchData(initialSearchData);
    setValueACBlCrMarca({
      id: "",
      descripcion: "",
    });
    setValueACBlCrMaterial({
      id: "",
      descripcion: "",
    });
    setValueACBlCrTipo({
      id: "",
      descripcion: "",
    });
    setValueACBlCrColor({
      id: "",
      descripcion: "",
    });
    setValueACBlCrDisponibleOs({
      id: "todo",
      descripcion: "Todos",
    });
    setValueACCrOrigen({
      id: "",
      descripcion: "",
    });

    setItemsCrud([]);
    setBlCrSubMarcas([]);
    setCurrentPage(0);
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    if (currentPage !== 0) {
      setCurrentPage(0);
    } else {
      load();
    }
  };
  //
  // ################################################################################
  //
  const load = async () => {
    let _params = {
      descripcion: searchData.descripcion,
      descripcionCorta: searchData.descripcionCorta,
      idBlCrTipo: searchData.idBlCrTipo,
      idBlCrMaterial: searchData.idBlCrMaterial,
      idCrOrigen: searchData.idCrOrigen,
      idBlCrMarca: searchData.idBlCrMarca,
      idBlCrSubmarca: searchData.idBlCrSubmarca,
      idBlCrColor: searchData.idBlCrColor,
      idBlCrDisponibleOs: searchData.idBlCrDisponibleOs ? searchData.idBlCrDisponibleOs : "T",
      estado: searchData.estado,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getCristalProductos(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      setTotalRowsCount(response.data.count);
      setItemsCrud(response.data.data);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleClickActionCrud = (itemCrud, action) => {
    let _itemCrud = {};

    if (action !== "new") {

      const loadItem = async () => {

        setIsDoingSomething(true);
        const response = await getCristalProducto({ id: itemCrud.id });
        setIsDoingSomething(false);

        if (response.ok) {
          let _response = response.data.data;
          _itemCrud = {
            id: _response.id,
            descripcion: _response.descripcion,
            descripcionCorta: _response.descripcion_corta,
            observaciones: _response.observaciones,
            crOrigen: {
              id: _response.id_cr_origen,
              label: _response.descripcion_cr_origen
            },
            blCrMarca: {
              id: _response.id_bl_cr_marca,
              label: _response.descripcion_bl_cr_marca
            },
            blCrSubMarca: {
              id: _response.id_bl_cr_submarca,
              label: _response.descripcion_bl_cr_submarca
            },
            blCrColor: {
              id: _response.id_bl_cr_color,
              label: _response.descripcion_bl_cr_color
            },
            blCrMaterial: {
              id: _response.id_bl_cr_material,
              label: _response.descripcion_bl_cr_material
            },
            blCrTipo: {
              id: _response.id_bl_cr_tipo,
              label: _response.descripcion_bl_cr_tipo
            },
            disponibleOs: _response.disponible_obra_social,
          };
          setActionCrud(action);
          setItemCrud(_itemCrud);
          setOpenDialog(true);
        } else {
          setMessage({
            severity: response.messageSeverity,
            messageText: response.messageText,
          });
          setShowMessage(true);
          return;
        }
      };
      loadItem();
    } else {
      setActionCrud(action);
      setItemCrud(_itemCrud);
      setOpenDialog(true);
    }
  };
  //
  // ################################################################################
  //
  const handleDialogSave = () => {
    load();
    setOpenDialog(false);
  };
  //
  // ################################################################################
  //
  const handleDialogClose = () => {
    setOpenDialog(false);
  };
  //
  // ################################################################################
  // 
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleBuscar();
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrMarcas = async () => {
    const response = await getCacheData("bl_cr_marca")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setBlCrMarcas(_var);
    } else {
      setBlCrMarcas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrSubMarcas = async (idBlCrMarca) => {
    setIsDoingSomething(true);
    const response = await getBlCrSubMarcas({ idBlCrMarca: idBlCrMarca });

    if (response.ok) {
      setIsDoingSomething(false);
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setBlCrSubMarcas(_var);
    } else {
      setIsDoingSomething(false);
      setBlCrSubMarcas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrMateriales = async () => {
    const response = await getCacheData("bl_cr_material")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setBlCrMateriales(_var);
    } else {
      setBlCrMateriales([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrTipos = async () => {
    const response = await getCacheData("bl_cr_tipo")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setBlCrTipos(_var);
    } else {
      setBlCrTipos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrColores = async () => {
    setIsDoingSomething(true);
    const response = await getCacheData("bl_cr_color")
    if (response.ok) {
      setIsDoingSomething(false);
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setBlCrColores(_var);
    } else {
      setIsDoingSomething(false);
      setBlCrColores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadCrOrigenes = async () => {
    const response = await getCacheData("cr_origen")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setCrOrigenes(_var);
    } else {
      setCrOrigenes([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="block" gutterBottom >
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="descripcion"
                  label="Descripcion"
                  variant="outlined"
                  size="small"
                  name="descripcion"
                  value={searchData.descripcion}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="descripcionCorta"
                  label="Descripcion Abreviada"
                  variant="outlined"
                  size="small"
                  name="descripcionCorta"
                  value={searchData.descripcionCorta}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-tipo"
                  size="small"
                  value={
                    valueACBlCrTipo && valueACBlCrTipo.id
                      ? valueACBlCrTipo
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACBlCrTipo(newValue);
                    setSearchData({
                      ...searchData,
                      idBlCrTipo: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACBlCrTipo}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACBlCrTipo(newInputValue);
                  }}
                  options={blCrTipos}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Tipo" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-material"
                  size="small"
                  value={
                    valueACBlCrMaterial && valueACBlCrMaterial.id
                      ? valueACBlCrMaterial
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACBlCrMaterial(newValue);
                    setSearchData({
                      ...searchData,
                      idBlCrMaterial: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACBlCrMaterial}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACBlCrMaterial(newInputValue);
                  }}
                  options={blCrMateriales}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Material" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-origen"
                  size="small"
                  value={
                    valueACCrOrigen && valueACCrOrigen.id
                      ? valueACCrOrigen
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACCrOrigen(newValue);
                    setSearchData({
                      ...searchData,
                      idCrOrigen: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACCrOrigen}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACCrOrigen(newInputValue);
                  }}
                  options={crOrigenes}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Origen" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-marca-producto"
                  size="small"
                  value={
                    valueACBlCrMarca && valueACBlCrMarca.id
                      ? valueACBlCrMarca
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACBlCrMarca(newValue);
                    setSearchData({
                      ...searchData,
                      idBlCrMarca: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACBlCrMarca}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACBlCrMarca(newInputValue);
                  }}
                  options={blCrMarcas}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Marca" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-sub-marca-producto"
                  size="small"
                  value={
                    valueACBlCrSubMarca && valueACBlCrSubMarca.id
                      ? valueACBlCrSubMarca
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACBlCrSubMarca(newValue);
                    setSearchData({
                      ...searchData,
                      idBlCrSubmarca: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACBlCrSubMarca}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACBlCrSubMarca(newInputValue);
                  }}
                  options={blCrSubMarcas}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="SubMarca" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-color"
                  size="small"
                  value={
                    valueACBlCrColor && valueACBlCrColor.id
                      ? valueACBlCrColor
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACBlCrColor(newValue);
                    setSearchData({
                      ...searchData,
                      idBlCrColor: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACBlCrColor}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACBlCrColor(newInputValue);
                  }}
                  options={blCrColores}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Color" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-disponible-os"
                  size="small"
                  value={
                    valueACBlCrDisponibleOs && valueACBlCrDisponibleOs.id
                      ? valueACBlCrDisponibleOs
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACBlCrDisponibleOs(newValue);
                    setSearchData({
                      ...searchData,
                      idBlCrDisponibleOs: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACBlCrDisponibleOs}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACBlCrDisponibleOs(newInputValue);
                  }}
                  options={disponibleOsOptions}
                  getOptionLabel={(option) => option.descripcion || ""}
                  renderInput={(params) => <TextField {...params} label="Disponible Obra Social" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="tipo-estado">
                    Estado
                  </InputLabel>
                  <Select
                    sx={{ width: "100%", mr: 1 }}
                    labelId="estado"
                    label="Estado"
                    id="estado"
                    name="estado"
                    value={searchData.estado}
                    size="small"
                    onChange={handleChange}
                  >
                    {estadoOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mx: 1, mb: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>

              {_crearCristalProducto && (
                <Grid item xs={12} md={12} lg={1}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Tooltip title="crear nuevo producto de cristal">
                      <Button
                        fullWidth
                        className="btn-add"
                        variant="contained"
                        size="small"
                        onClick={() => handleClickActionCrud({}, "new")}
                        startIcon={<Add />}
                      >
                        Nuevo
                      </Button>
                    </Tooltip>
                  </Box>
                </Grid>
              )}

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="buscar">
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="limpiar filtros">
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>

        <DataGrid
          rows={itemsCrud}
          columns={tableColumns}
          {...tableOptions}
        />
      </Paper>

      {openDialog && (
        <CristalProductoDialog
          onSave={handleDialogSave}
          onClose={handleDialogClose}
          itemCrud={itemCrud}
          actionCrud={actionCrud}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default CristalProductoTable;
